interface Tab {
  key: string;
  label: string;
  icon: string;
}

const tabs: Tab[] = [
  { key: "visao-geral", label: "Visão Geral", icon: "ri-eye-line" },
  { key: "localizacao", label: "Localização", icon: "ri-map-pin-line" },
  { key: "botanicos", label: "Dados Botânicos", icon: "ri-leaf-line" },
  { key: "fitossanidade", label: "Fitossanidade e Risco", icon: "ri-heart-pulse-line" },
  { key: "vistorias", label: "Vistorias", icon: "ri-clipboard-line" },
  { key: "fotos", label: "Fotos", icon: "ri-camera-line" },
  { key: "interferencias", label: "Interferências", icon: "ri-building-line" },
  { key: "manejo", label: "Manejo", icon: "ri-tools-line" },
  { key: "ocorrencias", label: "Ocorrências", icon: "ri-alarm-warning-line" },
  { key: "documentos", label: "Documentos e Fontes", icon: "ri-file-list-3-line" },
  { key: "historico", label: "Histórico", icon: "ri-history-line" },
];

interface Props {
  activeTab: string;
  onChange: (key: string) => void;
}

export default function TreeTabs({ activeTab, onChange }: Props) {
  return (
    <div className="bg-white rounded-card border border-background-200/70 p-1 flex overflow-x-auto gap-0.5">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          data-tab={tab.key}
          aria-label={tab.label}
          className={`flex items-center gap-1.5 px-3 py-2 rounded-btn text-xs font-medium whitespace-nowrap transition-colors duration-150 ${
            activeTab === tab.key
              ? "bg-primary-500 text-white"
              : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
          }`}
        >
          <i className={`${tab.icon} text-sm`}></i>
          <span className="hidden lg:inline">{tab.label}</span>
        </button>
      ))}
    </div>
  );
}